import api from "./apiV1";

export const getPublicEntityTypes = () => {
  return api.get("public-entities");
};
